import _ from "lodash";
import React, { PureComponent } from "react";
import classes from "./EmptyField.scss";
import PropTypes from "prop-types";
import { AddCircleIcon } from "SvgComponents";
import classNames from "classnames";
import { onEnterOrSpaceKeyDown } from "Utils";

const RenderIcon = ({ showAdd, renderIcon, testId }) => {
  let updatedRenderIcon = null;
  if (showAdd) {
    updatedRenderIcon = <AddCircleIcon width={24} height={24} />;
  }
  if (renderIcon) {
    updatedRenderIcon = renderIcon;
  }

  return (
    updatedRenderIcon && (
      <div className={classes.renderIcon} data-test-id={`${testId}-add-button`}>
        {updatedRenderIcon}
      </div>
    )
  );
};
class EmptyField extends PureComponent {
  render() {
    const {
      showAdd,
      onAddNewClick,
      containerStyle,
      title,
      isDisabled,
      renderIcon,
      theme,
      testId,
      dsVersion,
      isSinglePageAndNewUnitView,
    } = this.props;

    const isDsV2 = dsVersion === "2.0";
    const showButton = !isDisabled && showAdd;
    const containerClass = classNames(
      { [classes.container]: !showAdd },
      { [classes.containerButton]: showAdd },
      { [classes.disableButton]: isDisabled },
      { [classes.renderBlueTheme]: !!theme },
      { [classes.containerV2]: isDsV2 }
    );

    const containerUpdatedStyle = {
      ...containerStyle,
      cursor: showButton ? "pointer" : "auto",
    };
    const texts = _.split(title, "\n");
    const onAddNewClickOrKeydown = () => {
      if (showButton) onAddNewClick();
    };

    const titleClasses = classNames({
      [classes.title]: !isDsV2 && !isSinglePageAndNewUnitView,
      [classes.titleV2]: isDsV2,
      ["text-body"]: isDsV2 || isSinglePageAndNewUnitView,
    });

    return (
      <div
        className={containerClass}
        style={containerUpdatedStyle}
        onClick={onAddNewClickOrKeydown}
        onKeyDown={e => onEnterOrSpaceKeyDown(e, onAddNewClickOrKeydown)}
        tabIndex={showButton ? 0 : -1}
        data-test-id={`${testId}-emptyFieldCard`}
      >
        <RenderIcon showAdd={showAdd} renderIcon={renderIcon} testId={testId} />
        {texts[0] && (
          <div className={titleClasses} style={this.props.titleStyles}>
            {texts[0]}
          </div>
        )}
        {texts[1] && <div className={classes.subText}>{texts[1]}</div>}
      </div>
    );
  }
}

EmptyField.propTypes = {
  onAddNewClick: PropTypes.func,
  title: PropTypes.string,
  showAdd: PropTypes.bool,
  containerStyle: PropTypes.object,
  isDisabled: PropTypes.bool,
  renderIcon: PropTypes.any,
  dsVersion: PropTypes.string,
};

EmptyField.defaultProps = {
  title: "",
  showAdd: false,
  containerStyle: {},
  isDisabled: false,
  dsVersion: "1.0",
};

export default EmptyField;
